import Multiplexer from 'utilities/Multiplexer';
import Request from 'utilities/Request';
import {stringify} from 'querystring';

const multiplexer = new Multiplexer({
  flush(ids) {
    return Request.get(`/api/content/v3/users?id=${ids}`);
  },

  serialize(user) {
    return user.id;
  },
});

export const getUserById = id => multiplexer.add(id);

export const getUserDetailsByIds = ids =>
  Request.get(
    `/api/content/v2/users/details?fields=followers,created,emailAddress&ids=${ids.join(
      ','
    )}`
  );

export const fetchCardStatistics = id =>
  Request.get(`/userprofile/${id}/getKPIStats`);

export const fetchUsers = params => {
  const parameters = {
    ...params,
    includeDetails: true,
  };
  return Request.get(`/api/content/v3/users?${stringify(parameters)}`);
};
